import React, { Component } from 'react'
import _ from 'lodash'
import { t, Trans, Plural } from '@lingui/macro'
import {
  ButtonPrimary,
  ButtonClean,
  ButtonLight,
  Switch,
  Modal
} from 'front-end/src/components'
import ErrorMessage from '../../../components/common/error/ErrorMessage'
import Label from '../../../components/common/form/label/Label'
import IconPlus from '../../../components/common/icon/IconPlusInCircle'
import IconMinus from '../../../components/common/icon/IconMinus'
import Textarea from '../../../components/common/form/textarea/Textarea'
import UserAvatar, {
  PlaceholderAvatar
} from '../../../components/common/user/user-avatar/UserAvatar'
import GroupAvatar from '../../../components/common/group/group-avatar/GroupAvatar'
import TinyCard from '../../../components/common/card/tiny-card/TinyCard'
import Tooltip from '../../../components/common/tooltip/Tooltip'
import MembersSelector, {
  IMembersSelectorMembers,
  IMembersSelectorUser,
  IMembersSelectorGroup
} from '../../../components/common/members-selector/MembersSelector'
import { IResourceListItemCallbackArgs } from '../resource-list/ResourceListItem'
import './ResourceAssignmentModal.less'
import DateTimePickers from '../../../components/common/date-time-pickers/DateTimePickers'
import { OrganisationUsersAndGroupsQueryDocument } from './organisationUsersAndGroupsQuery.codegen'
import { AllGroupsDocument } from '../../../graphql/commonQueries/allGroups.codegen'
import { apolloClientPrivate } from '../../../graphql/apolloClient'
import { ResourceAssignmentButton } from './ResourceAssignmentButton'
import { ITopicEnrolment } from 'types/ITopicEnrolment'
import { SenderSelect } from '../../manage-campaign-page/campaign-new-action/SenderSelect'
import { Dayjs } from 'dayjs'

export default class ResourceAssignmentModal extends Component<
  {
    resourcesToAssign: IResourceListItemCallbackArgs[]
    workspaceId: number
    resolve: () => void
    reject: () => void
  },
  {
    showOverview: boolean
    showCustomMessage: boolean
    showCompletionDate: boolean
    isSearching: boolean
    membersFound: IMembersSelectorMembers
    membersSelected: IMembersSelectorMembers
    membersAddressBook: IMembersSelectorMembers
    message: string
    targetCompletionDate: Dayjs | null
    sharedCount: number | null
    assigningError: Error | null
    forceNewEnrolment: boolean
    emailIdentityId: number | null
  }
> {
  inputRef: HTMLInputElement | undefined | null
  membersSelectorRef: any

  defaultState = {
    isSearching: false,
    showOverview: false,
    showCustomMessage: false,
    showCompletionDate: false,
    membersFound: { users: [], groups: [] } as IMembersSelectorMembers,
    membersSelected: { users: [], groups: [] } as IMembersSelectorMembers,
    membersAddressBook: { users: [], groups: [] } as IMembersSelectorMembers,
    message: '',
    targetCompletionDate: null,
    forceNewEnrolment: false,
    sharedCount: null,
    assigningError: null,
    emailIdentityId: null
  }

  searchUsers = async (value: string) => {
    try {
      const response = await apolloClientPrivate.query({
        query: OrganisationUsersAndGroupsQueryDocument,
        variables: { search: value }
      })

      this.setState({
        membersFound: response.data
      })
    } catch (e) {
      console.error(e)
    } finally {
      this.setState({ isSearching: false })
    }
  }

  constructor(args) {
    super(args)
    this.state = _.cloneDeep(this.defaultState)
  }

  getDefaultStateWithAddressBookLoaded = () => {
    const defaultState = _.cloneDeep(this.defaultState)
    defaultState.membersAddressBook = this.state.membersAddressBook
    return defaultState
  }

  loadAddressBook = async () => {
    try {
      const result = await apolloClientPrivate.query({
        query: AllGroupsDocument
      })

      this.setState({
        membersAddressBook: {
          users: [],
          groups: result.data.groups
        }
      })
    } catch (e) {
      console.error(e)
    }
  }

  addMember = (
    user?: IMembersSelectorUser | null,
    group?: IMembersSelectorGroup
  ) => {
    const membersSelected = { ...this.state.membersSelected }
    if (user) {
      if (!this.state.membersSelected.users.find((u) => u.id === user.id)) {
        membersSelected.users.push(user)
      }
    } else if (group) {
      if (!this.state.membersSelected.groups.find((g) => g.id === group.id)) {
        membersSelected.groups.push(group)
      }
    }

    this.setState({ membersSelected })
  }

  removeMember = (
    user?: IMembersSelectorUser | null,
    group?: IMembersSelectorGroup
  ) => {
    const membersSelected = _.cloneDeep(this.state.membersSelected)
    if (user) {
      membersSelected.users = membersSelected.users.filter(
        (u) => u.id !== user.id
      )
    } else if (group) {
      membersSelected.groups = membersSelected.groups.filter(
        (g) => g.id !== group.id
      )
    }

    this.setState({ membersSelected })
  }

  renderSelection() {
    return (
      <>
        <MembersSelector
          onQueryChange={(value) => {
            this.setState({
              membersFound: { users: [], groups: [] },
              isSearching: true
            })
            this.searchUsers(value)
          }}
          onAdd={(
            user?: IMembersSelectorUser | null,
            group?: IMembersSelectorGroup
          ) => {
            this.addMember(user, group)
          }}
          onRemove={(
            user?: IMembersSelectorUser | null,
            group?: IMembersSelectorGroup
          ) => {
            this.removeMember(user, group)
          }}
          isSearching={this.state.isSearching}
          membersSearched={this.state.membersFound}
          membersSelected={this.state.membersSelected}
          addressBook={this.state.membersAddressBook}
          inputRef={(input) => {
            this.inputRef = input
          }}
        />
        <div className="custom-message">
          <ButtonClean
            size="sm"
            onClick={() => {
              const data = {
                showCustomMessage: !this.state.showCustomMessage,
                message: ''
              }
              this.setState(data)
            }}
            leftIcon={
              this.state.showCustomMessage ? <IconMinus /> : <IconPlus />
            }
          >
            {this.state.showCustomMessage ? (
              <Trans>Remove message</Trans>
            ) : (
              <Trans>Add message</Trans>
            )}
          </ButtonClean>
          <div
            className={
              this.state.showCustomMessage ? 'input-show' : 'input-hide'
            }
          >
            <Textarea
              placeholder={t`Add a message...`}
              value={this.state.message}
              onChange={(value) => {
                this.setState({ message: value })
              }}
              rows={2}
            />
          </div>
        </div>
        <SenderSelect
          value={this.state.emailIdentityId}
          onChange={(v) => this.setState({ emailIdentityId: v })}
        />
      </>
    )
  }

  renderShareMessage() {
    const resourcesToAssign = this.props.resourcesToAssign.length
    const membersSelected = this.state.membersSelected.users.length
    const groupsSelected = this.state.membersSelected.groups.length

    return (
      <div className="shareMessage">
        <Plural
          value={resourcesToAssign}
          _0="Sharing no resources"
          one={
            <Trans>
              Sharing <b>#</b> resource
            </Trans>
          }
          other={
            <Trans>
              Sharing <b>#</b> resources
            </Trans>
          }
        />

        <span>
          {' '}
          <Trans>with</Trans>{' '}
        </span>
        {membersSelected > 0 && (
          <Plural
            value={membersSelected}
            _0={null}
            one={
              <Trans>
                <b>#</b> user
              </Trans>
            }
            other={
              <Trans>
                <b>#</b> users
              </Trans>
            }
          />
        )}
        {` `}
        {membersSelected > 0 && groupsSelected > 0 && t`and`}
        {` `}
        {groupsSelected > 0 && (
          <Plural
            value={groupsSelected}
            _0={null}
            one={
              <Trans>
                <b>#</b> group
              </Trans>
            }
            other={
              <Trans>
                <b>#</b> groups
              </Trans>
            }
          />
        )}
      </div>
    )
  }

  renderOverview() {
    const usersToRender = this.state.membersSelected.users.slice(0, 8)
    const usersNotRendered = this.state.membersSelected.users.slice(8)
    const groupsToRender = this.state.membersSelected.groups.slice(
      0,
      8 - usersToRender.length
    )
    const groupsNotRendered = this.state.membersSelected.groups.slice(
      groupsToRender.length
    )
    const notRenderedCount = usersNotRendered.length + groupsNotRendered.length

    const resourcesToRender = this.props.resourcesToAssign.slice(0, 5)
    const resourcesNotRendered = this.props.resourcesToAssign.slice(
      resourcesToRender.length
    )

    return (
      <div className="selected-records">
        {this.renderShareMessage()}
        <div className="selected-resources">
          {resourcesToRender.map((resource) => {
            const res = resource.currentTopicVersion || resource.draftVersion
            return (
              <div className="tiny-card-wrapper" key={resource.id}>
                <Tooltip text={res.title}>
                  <TinyCard text={res.title} />
                </Tooltip>
              </div>
            )
          })}
          {resourcesNotRendered.length > 0 && (
            <div className="selected-resources-extra">
              <span>+{resourcesNotRendered.length} </span>
            </div>
          )}
        </div>
        <div className="selected-members">
          {usersToRender.map((user) => {
            return (
              <Tooltip key={user.id} text={user.display_name}>
                <UserAvatar
                  key={user.id}
                  user={{
                    display_name: user.display_name,
                    image_url: user.image_url
                  }}
                />
              </Tooltip>
            )
          })}
          {groupsToRender.map((group) => {
            return (
              <Tooltip key={group.id} text={group.name}>
                <GroupAvatar group={group} size="normal" key={group.id} />
              </Tooltip>
            )
          })}
          {notRenderedCount > 0 && (
            <PlaceholderAvatar text={`+${notRenderedCount}`} />
          )}
        </div>
        <div className="ResourceAssignmentModal__completion-date">
          <Label>
            <Trans>Set a target completion date?</Trans>
            <Switch
              onChange={() => {
                this.setState({
                  showCompletionDate: !this.state.showCompletionDate,
                  targetCompletionDate: null
                })
              }}
              isChecked={this.state.showCompletionDate}
            />
          </Label>
          {this.state.showCompletionDate && (
            <div className="date-input">
              <DateTimePickers
                disablePastDays
                value={this.state.targetCompletionDate}
                onChange={(date: Dayjs | null) => {
                  this.setState({
                    targetCompletionDate: date
                  })
                }}
              />
            </div>
          )}
        </div>
        <div className="ResourceAssignmentModal__enrol-reset-checkbox-wrapper">
          <Label>
            <div>
              <Trans>Reset progress</Trans>
              {` `}
              <em>
                <Trans>
                  When disabled, sharing will create new enrolments for all
                  selected users and will aim to maintain their progress, while
                  questions with incorrect answers and failed resources will be
                  available again. <br />
                  When enabled, new clear enrolments will be created and users
                  will need to start again.
                </Trans>
              </em>
            </div>
            <Switch
              onChange={() => {
                this.setState({
                  forceNewEnrolment: !this.state.forceNewEnrolment
                })
              }}
              isChecked={this.state.forceNewEnrolment}
            />
          </Label>
        </div>
      </div>
    )
  }

  onHide = () => {
    this.setState(this.getDefaultStateWithAddressBookLoaded())

    if (this.membersSelectorRef) {
      this.membersSelectorRef.reset()
    }

    this.props.reject()
  }

  onHidden = () => {
    if (this.hasFinished() || this.hasError()) {
      this.resetModal()

      this.props.resolve()
    }
  }

  resetModal = () => {
    this.setState(this.getDefaultStateWithAddressBookLoaded())
  }

  hasError() {
    return this.state.assigningError
  }

  hasFinished() {
    return !!this.state.sharedCount
  }

  renderError() {
    return (
      <ErrorMessage
        message={t`There was an error when creating this assignment`}
        error={this.state.assigningError}
        tiny
      />
    )
  }

  renderSuccess() {
    const sharedCount = this.state.sharedCount || 0

    return (
      <Plural
        value={sharedCount}
        one="You have successfully shared with # user"
        other="You have successfully shared with # users"
      />
    )
  }

  render() {
    const { props, state } = this
    const inviteesCount =
      this.state.membersSelected.users.length +
      this.state.membersSelected.groups.length

    const buttons: JSX.Element[] = []
    if (!this.hasError() && !this.hasFinished()) {
      buttons.push(
        <ButtonClean key="cancel" onClick={this.onHide}>
          <Trans>Cancel</Trans>
        </ButtonClean>
      )
    }

    let modalHeader = ''
    if (this.hasError()) {
      modalHeader = t`Sharing error`
      buttons.push(
        <ButtonPrimary
          key="close-error"
          onClick={() => {
            this.onHide()
          }}
        >
          <Trans>Close</Trans>
        </ButtonPrimary>
      )
    } else if (this.hasFinished()) {
      modalHeader = t`Resources shared`
      buttons.push(
        <ButtonPrimary
          key="close-finished"
          onClick={() => {
            this.onHide()
          }}
        >
          <Trans>Close</Trans>
        </ButtonPrimary>
      )
    } else if (this.state.showOverview) {
      modalHeader = t`Confirm details`
      buttons.push(
        <ButtonLight
          key="confirm"
          onClick={() => {
            this.setState({
              showOverview: false
            })
          }}
        >
          <Trans>Back</Trans>
        </ButtonLight>
      )
      buttons.push(
        <ResourceAssignmentButton
          key="share"
          forceNewEnrolment={state.forceNewEnrolment}
          topicIds={props.resourcesToAssign.map(({ id }) => id)}
          workspaceId={props.workspaceId}
          customEmailBody={state.message}
          targetCompletionDate={state.targetCompletionDate?.toDate()}
          userIds={state.membersSelected.users.map(({ id }) => id)}
          groupIds={state.membersSelected.groups.map(({ id }) => id)}
          emailIdentityId={state.emailIdentityId}
          sendEmail={true}
          onShared={(userEnrolments: ITopicEnrolment[][]) => {
            this.setState({ sharedCount: userEnrolments.length })
          }}
        />
      )
    } else {
      modalHeader = t`Select people to share with:`
      buttons.push(
        <ButtonPrimary
          disabled={inviteesCount === 0}
          key={'continue'}
          onClick={() => {
            this.setState({ showOverview: true })
          }}
        >
          <Trans>Continue</Trans>
        </ButtonPrimary>
      )
    }

    return (
      <Modal
        className="ResourceAssignmentModal"
        header={modalHeader}
        onHide={this.onHide}
        show
        onShown={() => {
          if (this.inputRef) {
            this.inputRef.focus()
            this.loadAddressBook()
          }
        }}
        onHidden={this.onHidden}
        controls={buttons}
      >
        {this.hasError() && this.renderError()}
        {this.hasFinished() && this.renderSuccess()}
        {!this.hasFinished() &&
          !this.state.showOverview &&
          this.renderSelection()}
        {!this.hasFinished() &&
          this.state.showOverview &&
          this.renderOverview()}
      </Modal>
    )
  }
}
